<template>
    <div>
        <div>
            {{ $t("Gallery Visibility") }}
        </div>
        <b-dropdown variant="light" toggle-class="rounded-pill" size="lg">
            <template #button-content>
                <span v-if="creatorGallery.secret">
                    <font-awesome-icon
                        class="branded"
                        icon="fa-duotone fa-face-shush"
                    />
                    {{ $t("Secret") }}
                </span>
                <span v-else>
                    <font-awesome-icon
                        icon="fa-duotone fa-globe"
                        class="text-primary"
                    />
                    {{ $t("Public") }}
                </span>
            </template>

            <b-dropdown-header>
                {{ $t("Visibility") }}
            </b-dropdown-header>
            <b-dropdown-item
                link-class="py-3"
                :class="{ 'border-primary': !creatorGallery.secret }"
                @click="setSecret(null)"
            >
                <div>
                    <span class="text-primary">
                        <font-awesome-icon icon="fa-duotone fa-globe" />
                    </span>
                    {{ $t("Public") }}
                </div>
                <div class="small text-secondary">
                    {{ $t("Available for sale to all customers") }}
                </div>
            </b-dropdown-item>
            <b-dropdown-item
                link-class="py-3"
                :class="{ 'border-primary': creatorGallery.secret }"
                @click="setSecret(1)"
            >
                <div>
                    <span class="branded">
                        <font-awesome-icon
                            icon="fa-duotone fa-face-shush"
                            class="branded"
                        />
                    </span>
                    {{ $t("Secret") }}
                </div>
                <div class="small text-secondary">
                    {{ $t("Unlisted, invite-only gallery") }}
                </div>
            </b-dropdown-item>
        </b-dropdown>

        <b-alert
            v-if="creatorGallery.secret"
            show
            variant="warning"
            class="small mt-3"
        >
            <h5>
                {{ $t("Secret Gallery Warning") }}
            </h5>
            <font-awesome-icon icon="fa-duotone fa-triangle-exclamation" />
            {{
                $t(
                    "Gallery will not be listed on your profile, or on the gallery marketplace. Only customers you share or invite your gallery to will be able to view it"
                )
            }}
        </b-alert>
    </div>
</template>

<script>
export default {
    methods: {
        setSecret(value) {
            this.api
                .post("/creatorGallery/secret", {
                    creatorGalleryId: this.creatorGallery.id,
                    enable: value,
                })
                .then(() => {
                    this.$store.dispatch("creatorGallery/refreshGallery");
                });
        },
    },
    props: ["creatorGallery"],
};
</script>